'use strict';

(function () {
    'use strict';

    angular.module('customIframe', ['ui.router', 'common']);
})();